<script>
import {mergeData} from 'vue-functional-data-merge'

export default {
  name: 'Icon',
  functional: true,
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  render(h, {props, data}) {
    return h('i', mergeData(data, {
      class: [
        props.icon
      ]
    }))
  }
}
</script>
